import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LanguageMenuComponent } from '../language-menu/language-menu.component';
import { Router, RouterModule } from '@angular/router';
import { LoginMenuComponent } from '../login-menu/login-menu.component';
import { CatalogSearchComponent } from '../search-bar/search-bar.component';
import { CartInfoComponent } from '../cart-info/cart-info.component';
import { BookmarkInfoComponent } from '../bookmark-info/bookmark-info.component';
import { LocationIndicatorComponent } from '../location-indicator/location-indicator.component';
import { CatalogFilter } from 'src/app/common/CatalogFilter';
import { AppProfileService } from '../../services/profile.service';
import { ExtendedProfile } from '../../common/ExtendedProfile';

@Component({
    imports: [RouterModule, LanguageMenuComponent, LoginMenuComponent, CatalogSearchComponent, CartInfoComponent, BookmarkInfoComponent, LocationIndicatorComponent],
    selector: 'app-main-nav',
    templateUrl: './main-nav.component.html',
    styleUrls: ['./main-nav.component.css']
})
export class MainNavComponent implements OnInit {
  private router = inject(Router);
  private profileService = inject(AppProfileService);

  private destroyRef = inject(DestroyRef);

  public profile: ExtendedProfile;

  ngOnInit(): void {
    this.profileService.currentProfile$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((p) => {
        this.profile = p;
      });
  }

  search($event: CatalogFilter) {
    this.router.navigate(['/search'], {
      queryParams: {
        name: $event.name || null,
        categoryId: $event.categoryId || null,
        productSkuId: $event.productSkuId || null,
      },
    });
  }

}
